import angular from 'angular';

import Case from '../models/case';
import Errors from '../models/errors';
import Customer from '../models/customer';

class PaymentStatus {
	constructor(CurrentCase, CurrentCustomer, Errors) {
		this.errors = Errors;

		this.expireMessages = {
			user: {
				error: 'No payment attached',
				details: 'There is no payment attached. To access all functionality, please upgrade to a paid plan. <div><a class="btn btn-success pull-right" href="/app/#/account?tab=firm">Upgrade</a></div>'
			},
			case: {
				error: 'No payment attached',
				details: 'The trial period on this case has expired and/or there is no payment attached. To open all functionality for this case, please upgrade to a paid plan. <div><a class="btn btn-success pull-right" href="/app/#/account?tab=firm">Upgrade</a></div>'
			}
		}
		this.statusData = {
			user: function (obj) {
				var testObj = obj || CurrentCustomer.data || {
					status: -1
				};
				return testObj.status;
			},
			case: function (obj) {
				var testObj = obj || CurrentCase.data || {
					subscription: {
						status: 0
					}
				};
				return testObj.subscription &&
					testObj.subscription.status;
			}
		}
		this.warningData = {
			user: function (obj) {
				var testObj = obj || CurrentCustomer.data || {
					hideStatusWarning: false
				};
				return testObj.hideStatusWarning;
			},
			case: function (obj) {
				var testObj = obj || CurrentCase.data || {
					hideStatusWarning: false
				};
				return testObj.subscription &&
					testObj.subscription.hideWarning;
			}
		}
	}

	setType(type) {
		return (type === 'user' ? 'user' : 'case');
	}

	setExpiredMsg(type) {
		this.errors.data['/#/plan'] =
			this.expireMessages[this.setType(type)];
	}

	getStatus(type, testObj) {
		return this.statusData[this.setType(type)](testObj);
	}

	getStatusTxt(type, testObj) {
		var s = this.statusData[this.setType(type)](testObj);
		return s > 0 ? 'TRIAL' : s < 0 ? 'UNPAID' : s === 0 ? 'PAID' : '';
	}

	isExpired(type, testObj) {
		return (this.statusData[this.setType(type)](testObj) < 0);
	}

	isTrial(type, testObj) {
		return (this.statusData[this.setType(type)](testObj) > 0);
	}

	isValid(type, testObj) {
		return (this.statusData[this.setType(type)](testObj) === 0);
	}

	showWarning(type, testObj) {
		return !this.warningData[this.setType(type)](testObj);
	}
}
PaymentStatus.$inject = ['CurrentCase', 'CurrentCustomer', 'Errors'];

export default angular.module('services.payment-status', [Case, Customer])
	.service('PaymentStatusServ', PaymentStatus)
	.name;



// WEBPACK FOOTER //
// ./project/services/payment-status.js